
import { Component, Vue, Prop } from 'vue-property-decorator'
import { calcIntReadRatio } from '@/common/utils'

@Component({})
export default class RankTable extends Vue {
    @Prop({ required: true }) private value!: any[]

    private calcScorePercent(score: number) {
        return (score / 1000 * 100) + '%'
    }

    // 计算互动比例（千分比）
    private calcIntReadRatio(interactCount: number, readCount: number) {
        return calcIntReadRatio(interactCount, readCount, true)
    }

    private matchLeft(rank: number) {
        const len = String(rank).length
        if (len === 2) {
            return 'hundred'
        } else if (len === 3) {
            return 'thousand'
        } else if (len === 4) {
            return 'manyw'
        } else {
            return ''
        }
    }
}
